import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { useHistory } from "react-router"
import styled from "styled-components"
import { post, get } from "../../netApi/fetch"
import BanUnLogin from "../../high-component/BanUnLogin"
import Main from "../../high-component/Content"
import { Modal, Spin, message } from "antd"
import { PlayCircleOutlined, PauseCircleOutlined, RightOutlined } from "@ant-design/icons"

// ===== styled 组件 =====
const ActionButton = styled.button`
  cursor: pointer;
  border-radius: 50vmin;
  background: var(--theme-main);
  color: #fff;
  padding: 8px 20px;
  font-size: 14px;
  border: none;
  font-weight: bold;
  &:hover {
    opacity: 0.8;
  }
`

const TextArea = styled.textarea`
  width: 100%;
  min-height: 400px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  font-size: 16px;
  line-height: 1.6;
  resize: vertical;
  outline: none;
`

const VideoList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
`

const VideoItem = styled.div`
  position: relative;
  width: 200px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.3s,
    box-shadow 0.3s;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  &.selected::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    z-index: 2;
    pointer-events: none;
  }
`

const VideoPlayer = styled.video`
  width: 100%;
  height: 320px;
  object-fit: cover;
  border-radius: 12px;
  background: #000;
`

const VideoInfo = styled.div`
  padding: 12px;
  background: #fff;
`

const VideoTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const VideoTime = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
`

const ModalSection = styled.div`
  margin-bottom: 20px;
  text-align: left;
`

const GrayBox = styled.div`
  background: #f2f2f2;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  margin-top: 8px;
  max-width: 85%;
  min-width: 85%;
  float: left;
`

const ContentContainer = styled.div`
  margin-top: 40px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`

const LeftPanel = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

const RightPanel = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
`

// 全局加载蒙版
const GlobalLoadingOverlay = styled.div`
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  backdrop-filter: blur(2px);
  border-radius: 12px;
`

const LoadingContent = styled.div`
  background: #fff;
  padding: 40px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
`

const LoadingText = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
`

const LoadingSubText = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
`

const LoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3ca7b5;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const IPCreationPage = (props) => {
  const history = useHistory()
  const [textContent, setTextContent] = useState("")
  const [modalVisible, setModalVisible] = useState(false)

  // 声音模型
  const [soundText, setSoundText] = useState("")
  const [soundUrl, setSoundUrl] = useState("")
  const [soundId, setSoundId] = useState(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [audioError, setAudioError] = useState(false)
  const audioRef = React.useRef<HTMLAudioElement | null>(null)

  // 视频模型
  const [contentList, setContentList] = useState<any[]>([])
  const [viewOffsetIndex, setViewOffsetIndex] = useState(0)
  const [viewLength, setViewLength] = useState(0)
  const [selectedVideoId, setSelectedVideoId] = useState<string | number | null>(null)
  const limit = 5
  const [loading, setLoading] = useState(false)

  const [generating, setGenerating] = useState(false)
  const [generatedVideo, setGeneratedVideo] = useState<any>(null)

  // ========== API ==========
  // 获取音频接口
  const fetchSoundModel = () => {
    setSoundText("看着窗外缓缓下落的雨滴，滴答声成了最好的背景音乐，拿起笔，写下了心中的所思所想，雨天也有独特的韵味。")
    setSoundUrl("")
    setAudioError(false)
    get("/ip/viewmp3", {})
      .then((res) => {
        console.log("fetchSoundModel :>> ", res)
        setSoundUrl(res.url || "")
        setSoundId(res.id || null)
      })
      .catch(() => {
        setSoundText("音频加载失败")
        setSoundUrl("")
        setAudioError(true)
      })
  }
  useEffect(() => {
    fetchSoundModel()
  }, [])

  const handleGetContentList = (reset = false) => {
    setLoading(true)
    const offset = reset ? 0 : viewOffsetIndex * limit
    get(`/ip/viewmp4list?offset=${offset}&limit=${limit}`, {}).then((res) => {
      setViewLength(res.count || 10)
      if (reset) {
        setContentList(res.list || [])
        setViewOffsetIndex(1)
      } else {
        setContentList([...contentList, ...(res.list || [])])
        setViewOffsetIndex(viewOffsetIndex + 1)
      }
      if (res.list.length > 0 && !selectedVideoId) {
        setSelectedVideoId(res.list[0].id)
      }
      setLoading(false)
    })
  }

  const handleGenerateVideo = () => {
    setGenerating(true)
    post("/ip/createvideo", { text: textContent, soundUrl, videoId: selectedVideoId, soundId: soundId })
      .then((res) => {
        console.log("handleGenerateVideo :>> ", res)
        setGenerating(false)
        message.success("AI视频生成成功！")
        setGeneratedVideo(res.data.video_url)
        setModalVisible(false)
      })
      .catch((err) => {
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
        console.log("handleGenerateVideo error :>> ", err)
      })
  }

  // ========== 按钮 ==========
  const saveOnly = () => {
    console.log("仅保存文本:", textContent)

    if (textContent.trim()) {
      post("/content/create?app=jieligo", {
        title: "",
        content: textContent,
        type: 1,
        image: "",
        imageids: [],
      }).then((res) => {
        console.log("res :>> ", res)
        handleGetContentList(true)
        message.success("文本保存成功")
      })
    } else {
      message.warning("请输入文本内容")
    }
  }

  const saveAndGenerate = () => {
    if (!textContent.trim()) {
      message.warning("请输入文本内容")
      return
    }
    handleGetContentList(true)
    setModalVisible(true)
  }

  // ========== 音频控制 ==========
  const togglePlay = () => {
    if (!audioRef.current || audioError || !soundUrl) return
    if (isPlaying) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  const isLogin = props.user?.uid
  return (
    <div
      style={{
        maxWidth: "780px",
        position: "relative",
        width: "100%",
        minWidth: "300px",
        margin: "0 auto",
        paddingTop: "90px",
        minHeight: "100vh",
        padding: "0 0 40px",
        marginTop: "10px",
      }}
    >
      {/* 顶部导航栏 */}
      <div
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          right: 0,
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 16px",
          zIndex: 10,
        }}
      >
        {/* 返回按钮 */}
        <div
          style={{
            background: "#fff",
            borderBottom: "1px solid #eee",
            cursor: generating ? "not-allowed" : "pointer",
            fontSize: "14px",
            color: "#333",
            padding: "10px 20px",
            borderRadius: "50vmin",
            fontWeight: "bold",
            opacity: generating ? 0.6 : 1,
          }}
          onClick={generating ? undefined : history.goBack}
        >
          返回上一页
        </div>

        {/* 中间标题 */}
        <div
          style={{
            background: "#fff",
            borderBottom: "1px solid #eee",
            cursor: "pointer",
            fontSize: "14px",
            color: "#333",
            padding: "10px 20px",
            borderRadius: "50vmin",
            fontWeight: "bold",
          }}
        >
          IP内容生成
        </div>

        {/* 右侧按钮 */}
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => saveOnly()}
            disabled={generating}
            style={{
              backgroundColor: "#3ca7b5",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              borderRadius: "50vmin",
              fontSize: "14px",
              cursor: generating ? "not-allowed" : "pointer",
              opacity: generating ? 0.6 : 1,
              fontWeight: "bold",
            }}
          >
            仅保存
          </button>
          <button
            onClick={() => saveAndGenerate()}
            disabled={!isLogin || generating}
            style={{
              backgroundColor: "#3ca7b5",
              color: "#fff",
              fontSize: "14px",
              cursor: !isLogin || generating ? "not-allowed" : "pointer",
              opacity: !isLogin || generating ? 0.6 : 1,
              border: "none",
              padding: "10px 20px",
              borderRadius: "50vmin",
              fontWeight: "bold",
            }}
          >
            {generating ? "生成中..." : "保存并生成视频"}
          </button>
        </div>
      </div>

      <ContentContainer>
        <LeftPanel>
          <h3 style={{ marginBottom: "16px", color: "#333" }}>输入文本内容</h3>
          <TextArea
            placeholder="请输入要生成的文本内容..."
            value={textContent}
            onChange={(e) => setTextContent(e.target.value)}
            disabled={generating}
            style={{
              // 吸收剩余高度
              height: `calc(100vh - 400px)`,
              opacity: generating ? 0.6 : 1,
              cursor: generating ? "not-allowed" : "text",
            }}
          />
        </LeftPanel>
      </ContentContainer>
      <RightPanel
        style={{
          /*脱离原有的布局，设置绝对定位到右侧*/ position: "absolute",
          right: "-310px",
          top: "90px",
          width: "300px",
          minHeight: "calc(100vh - 310px)",
        }}
      >
        <h3>视频模板</h3>
        {/* 全局加载蒙版 */}
        {generating ? (
          <GlobalLoadingOverlay>
            <LoadingContent>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                <LoadingSpinner />
              </div>
              <LoadingText>AI视频生成中...</LoadingText>
              <LoadingSubText>
                正在为您生成高质量的AI视频内容
                <br />
                预计需要3-5分钟，请耐心等待
              </LoadingSubText>
            </LoadingContent>
          </GlobalLoadingOverlay>
        ) : generatedVideo ? (
          <video
            controls
            style={{
              width: "100%",
              height: "320px",
              objectFit: "cover",
              borderRadius: "12px",
              background: "#000",
            }}
          >
            <source src={generatedVideo} />
            您的浏览器不支持视频播放
          </video>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              minHeight: "260px",
              color: "#666",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: 80,
                height: 80,
                background: "#f2f6fa",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 16,
              }}
            >
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                <defs>
                  <image id="image_0" width="200.000000" height="200.000000" xlinkHref={require("../../images/mp4Default.png")} />
                  <pattern id="pattern_0" width="1.000000" height="1.000000" image-fill-type="fill" patternContentUnits="objectBoundingBox">
                    <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_0" />
                  </pattern>
                </defs>
                <rect id="ico-navigation-voiceover 1" width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_0)" />
              </svg>
            </div>
            <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8 }}>确认要表达的文字后</div>
            <div style={{ fontSize: 14, color: "#999" }}>即可生成AI视频</div>
          </div>
        )}
      </RightPanel>

      {/* 弹窗 */}
      <Modal title="请确认模型" open={modalVisible} onCancel={() => setModalVisible(false)} footer={null} width={800}>
        <ModalSection>
          <h4>声音模型</h4>
          <GrayBox>{soundText}</GrayBox>
          <div style={{ marginTop: 20, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ flex: 1 }} />
            <ActionButton
              onClick={togglePlay}
              style={{ float: "right", minWidth: 80, opacity: audioError || !soundUrl ? 0.5 : 1, cursor: audioError || !soundUrl ? "not-allowed" : "pointer" }}
              disabled={audioError || !soundUrl}
            >
              {isPlaying ? <PauseCircleOutlined /> : <PlayCircleOutlined />} 试听
            </ActionButton>
            <audio
              ref={audioRef}
              src={soundUrl}
              onEnded={() => setIsPlaying(false)}
              onError={() => {
                setAudioError(true)
                setIsPlaying(false)
              }}
            />
          </div>
        </ModalSection>

        <br />

        <ModalSection>
          <h4>视频模型</h4>
          {loading ? (
            <Spin />
          ) : (
            <>
              <VideoList>
                {contentList.map((item) => (
                  <VideoItem key={item.id} className={selectedVideoId === item.id ? "selected" : ""} onClick={() => setSelectedVideoId(item.id)}>
                    <VideoPlayer controls>
                      <source src={item.url} />
                      您的浏览器不支持视频播放
                    </VideoPlayer>
                    <VideoInfo>
                      <div style={{ float: "left" }}>
                        <VideoTitle>{item.filename}</VideoTitle>
                        <VideoTime>{item.updatetime}</VideoTime>
                      </div>
                    </VideoInfo>
                  </VideoItem>
                ))}
              </VideoList>
              {contentList.length < viewLength && (
                <div style={{ textAlign: "right", marginTop: 10 }}>
                  <RightOutlined onClick={() => handleGetContentList()} style={{ fontSize: 20, cursor: "pointer" }} />
                </div>
              )}
            </>
          )}
        </ModalSection>

        <div style={{ textAlign: "center" }}>
          <ActionButton
            onClick={() => {
              handleGenerateVideo()
              setModalVisible(false) // 生成后收起弹窗
            }}
            disabled={!selectedVideoId || generating}
            style={{
              opacity: !selectedVideoId || generating ? 0.5 : 1,
              cursor: !selectedVideoId || generating ? "not-allowed" : "pointer",
            }}
          >
            {generating ? "生成中..." : "生成AI视频"}
          </ActionButton>
        </div>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.login_user_data,
    loginBindInfo: state.loginBindInfo,
  }
}

export default BanUnLogin(Main(connect(mapStateToProps)(IPCreationPage)))
